var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tr", [
    _c("td", [_vm._v(_vm._s(_vm.timeCreated))]),
    _c("td", { staticClass: "amount" }, [
      _vm._v(" " + _vm._s(_vm.total) + " "),
    ]),
    _c(
      "td",
      [
        _vm.history.Contact && _vm.history.Contact.MainAddress
          ? [_vm._v(_vm._s(_vm.history.Contact.MainAddress.CompanyName))]
          : _vm._e(),
      ],
      2
    ),
    _c("td", [_vm._v(_vm._s(_vm.history.FriendlySaleID))]),
    _c("td", [_c("small", [_vm._v(_vm._s(_vm.history.Info))])]),
    _c("td"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }